































import {Vue, Component, Prop, Emit, Watch} from 'nuxt-property-decorator'
import sanitize from 'sanitize-html'

import http from '../../utils/http'

const extractAttr = (s: string, attr: string) => {
  const start = s.slice(s.search(`${attr}="`)).slice(attr.length + 2)
  return start.slice(0, start.search(/["]/g))
}

@Component
class ChartModal extends Vue {
  @Prop({type: Object, required: true})
  editor: any

  @Prop({type: String, required: true})
  token: string

  @Prop({type: String, required: true})
  imageUploadUrl: string

  images = []
  code: string = ''
  alt: string = ''

  get isValid() {
    return this.code.length > 10 && this.alt.length > 0 && this.uploadedImage
  }

  get uploadedImage() {
    return this.images[0]
  }

  async insertChart() {
    const html = sanitize(this.code, {
      disallowedTagsMode: 'discard',
      allowedTags: ['iframe', 'div'],
      allowedAttributes: {
        div: ['class', 'data-url', 'data-w', 'data-h', 'data-domain'],
        iframe: ['src', 'class', 'style', 'height', 'width', 'loading'],
      },
    })

    const tag = html.includes('data-url') ? 'div' : 'iframe'

    if (tag === 'div') {
      const dataUrl = extractAttr(html, 'data-url')
      const dataW = extractAttr(html, 'data-w')
      const dataH = extractAttr(html, 'data-h')
      const dataDomain = extractAttr(html, 'data-domain')
      const _class = extractAttr(html, 'class')

      this.editor.commands.visme({
        class: _class,
        dataUrl,
        dataW,
        dataH,
        dataDomain,
      })
    } else {
      const src = extractAttr(html, 'src')
      const style = extractAttr(html, 'style')
      const height = extractAttr(html, 'height')
      const width = extractAttr(html, 'width')
      this.editor.commands.iframe({
        src,
        style,
        height,
        width,
        img: this.images[0].link,
        alt: this.alt,
      })

      this.$emit('close')
    }
  }

  async uploadImage(event) {
    const {files = []} = event.target
    const formData = new FormData()
    formData.append('file', files[0])

    const {data} = await http.post(this.imageUploadUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: this.token,
      },
    })

    this.images = [data]
  }

  removeImage() {
    this.images = []
  }
}

export default ChartModal
